export default "__VITE_ASSET__DDWXvhpl__"